import React from 'react';
import "./dotLoader.css"


class EpflLoader extends React.Component {


    render() {
        return (
            <div style={{display:"flex",
                width:"auto", height:"50px"}}>
                <span className="dotLoader" 
                    style={{position :"relative",left:"45%",
                        animationDelay:"-0.4s"}}></span>
                <span className="dotLoader" 
                    style={{position :"relative",left:"50%"}}></span>
                <span className="dotLoader" 
                    style={{position :"relative",left:"55%",
                        animationDelay:"0.4s"}}></span>
            </div>
        )
    }
}

export default EpflLoader;